import { Component, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef, OnInit } from '@angular/core';
import { NotificationComponent } from './components/notification/notification.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NotificationService } from './services/notification.service';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'lds-gateway';
  expanded = false;
  lastMessageCode: string | undefined;

  @ViewChild('notificationWrapper', {
    read: ViewContainerRef
  })
  alertContainer!: ViewContainerRef;
  lastNotification: ComponentRef<NotificationComponent> | null = null;

  constructor(
    private router: Router,
    private titleService: Title,
    private service: NotificationService,
    private resolver: ComponentFactoryResolver) {
    this.service.Notifications.subscribe(x => {
      if (x) this.createNotificationElement(x);
    })
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(`${this.title} - ${title}`);
        }
      });
  }

  createNotificationElement(notification: { Type: 'info' | 'success' | 'danger' | 'error', Message: string, Body: string }) {

    if (notification.Message == this.lastMessageCode && this.lastNotification != null) {
      // update previous notification if it exists
      if (this.lastNotification.instance.Notification.Count) {
        this.lastNotification.instance.Notification.Count = this.lastNotification.instance.Notification.Count + 1
      }
      else {
        this.lastNotification.instance.Notification.Count = 1
      }
      return;
    }

    this.lastMessageCode = notification.Message;
    const factory = this.resolver.resolveComponentFactory(NotificationComponent);
    const componentRef: ComponentRef<NotificationComponent> = this.alertContainer.createComponent(factory);

    componentRef.instance.Notification = notification;
    componentRef.instance.Ref = componentRef;

    this.lastMessageCode = notification.Message;
    this.lastNotification = componentRef;

    this.triggerSelfdestruc(componentRef);
  }

  triggerSelfdestruc(componentRef: ComponentRef<NotificationComponent>) {
    componentRef.instance.Timeout = setTimeout(() => {
      componentRef.destroy();
      this.lastNotification = null;
    }, 10000);

    componentRef.instance.destroy.subscribe(x => {
      clearTimeout(x.instance.Timeout);
      x.instance.Notification.Count = 0;
      x.destroy();
      this.lastNotification = null;
    });
  }
}
